import { ValidatorFn, Validators } from '@angular/forms';

export const PATTERNS = {
  NO_SPECIAL_CHAR: /^[a-zA-Z0-9_' ]*$/,
  PASSWORD_COMPLEXITY: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\\W_]).+$/,
  WEBSITE_URL: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
  MOBILE_NUMBER: /^[0-9]{10}$/,
  POSTAL_CODE: /^[0-9]{5}(?:-[0-9]{4})?$/,
  ALPHABET_WITH_SPACE: /^[a-zA-Z\s-]*$/,
  ALPHABET_WITH_SPACE_AND_NUMBER: /^[a-zA-Z0-9_' ]*$/,
  ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR: /^[a-zA-Z0-9\s-@#$%^&*()_+={}|\\:;<>,.?/`~]*$/,
  ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR_AND_HYPHEN:
    /^[a-zA-Z0-9\s-@#$%^&*()_+={}|\\:;<>,.?/`~-]*$/,
  COMMON_ID: /^[A-Za-z]{4}\d+$/,
  /** Email local/domain must not contain whitespace (use with Validators.email). */
  EMAIL_NO_WHITESPACE: /^\S+$/,
  PASSWORD: {
    HAS_LOWERCASE: /[a-z]/, // At least one lowercase letter
    HAS_UPPERCASE: /[A-Z]/, // At least one uppercase letter
    HAS_NUMBER: /\d/, // At least one digit
    HAS_SPECIAL_CHAR: /[@$!%*?&]/, // At least one special character from @$!%*?&
    VALID_CHAR_SET: /^[A-Za-z\d@$!%*?&]+$/, // Only these characters are allowed
    MIN_LENGTH: /^.{8,}$/, // At least 8 characters
  },
};

/** Standard validators for email fields (format + no spaces). Add Validators.required when needed. */
export const EMAIL_FIELD_VALIDATORS: ValidatorFn[] = [
  Validators.email,
  Validators.pattern(PATTERNS.EMAIL_NO_WHITESPACE),
];
